const appConfig = {
  "name": "onboarding-web-main",
  "version": "0.1.0",
  "stage": "dev",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697",
    "clientId": "5s8731sfovq6gr5ekiivbrmor7",
    "redirectUris": [
      "https://onboarding.atlas-apps-dev.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://onboarding.atlas-apps-dev.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "covid19/user",
      "digital-id/user",
      "email",
      "offline_access",
      "onboarding/user",
      "openid",
      "phone",
      "profile",
      "user/admin.visiting-student",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_14cFcpuS8",
    "userPoolWebClientId": "5s8731sfovq6gr5ekiivbrmor7",
    "oauth": {
      "domain": "atlas-auth-dev.mit.edu",
      "scope": [
        "covid19/user",
        "digital-id/user",
        "onboarding/user",
        "openid",
        "profile",
        "user/admin.visiting-student",
        "user/all"
      ],
      "redirectUris": [
        "https://onboarding.atlas-apps-dev.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://onboarding.atlas-apps-dev.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;